import { Component, OnInit, ViewChild } from '@angular/core';
import { EmployeeService } from '../services/employee.service';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-employee-create',
  templateUrl: './employee-create.component.html',
  styleUrls: ['./employee-create.component.css']
})
export class EmployeeCreateComponent implements OnInit {

  @ViewChild('form') form: NgForm;
  @ViewChild('emailField') emailField: NgModel;

  isSavingInfo: boolean = false;
  emailAvailable: boolean = false;
  emailMsg: string = "";

  // add employee
  newEmployee: NewEmployee = {
    user_email: '',
    first_name: '',
    last_name: '',
    legal_first_name: '',
    legal_last_name: '',
    phone: '',
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    zip_code: '',
    QM_rate: 0,
    hourly_rate: 0,
    contractor: false,
    employee_type: '',
    active: false
  };
  successMessage: string = "";
  constructor(private employeeService: EmployeeService, private router: Router) { }

  ngOnInit(): void {
  }

  resetNewEmployee() {
    this.newEmployee.QM_rate = 0;
    this.newEmployee.hourly_rate = 0;
    this.newEmployee.address_1 = "";
    this.newEmployee.address_2 = "";
    this.newEmployee.city = "";
    this.newEmployee.state = "";
    this.newEmployee.zip_code = "";
    this.newEmployee.contractor = false;
    this.newEmployee.first_name = "";
    this.newEmployee.last_name = "";
    this.newEmployee.phone = "";
    this.newEmployee.user_email = "";
    this.newEmployee.legal_first_name = "";
    this.newEmployee.legal_last_name = "";
    this.newEmployee.employee_type = "";
    this.successMessage = "";
    this.isSavingInfo = false;


    this.emailMsg = "";
    this.emailAvailable = false;
  }

  async saveEmployee(form: NgForm) {
    if (form.valid && this.emailAvailable) {
      try {
        this.isSavingInfo = true;
        this.successMessage = "";
        let result = await this.employeeService.newEmployee(this.newEmployee).toPromise();
        this.isSavingInfo = false;
        this.successMessage = "A new employee has been created.";
        this.resetNewEmployee();
        this.form.resetForm();
        if(result){
          setTimeout(() => {
            this.router.navigate(['/employees/' + result?.employee_id + '/details']);
          }, 500);
        }


      } catch (error) {
        this.isSavingInfo = false;
        this.successMessage = "An error occured. Please try again later";
        if (error?.error?.detail) {
          if (JSON.parse(error.error.detail)) {
            let errMsg = JSON.parse(error.error.detail).message;
            this.successMessage = errMsg;
          }
        }

      }
    }
  }

  async checkEmail(){
    if(!this.isValidEmail(this.newEmployee.user_email)){
      this.emailMsg = "Invalid Email";
      this.emailAvailable = false;
      return;
    }
    this.emailMsg = "";
    let result = await this.employeeService.checkEmail({"email": this.newEmployee.user_email}).toPromise();
    this.emailAvailable = result;
    if( result === false ){
      this.emailMsg = "Email is already in use by an employee";
    }else{
      this.emailMsg = "Email is available";
    }

  }

  isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

}
